import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MeetingParticipantDto } from '@interfaces/meetings/responses/meeting.response';
import {
  agruparParticipantes,
  nomeDoParticipante,
} from '@features/dashboard/meetings/components/meeting-presenter';

/**
 * Participantes da ligação agrupados por tipo — Legatus, Empresa, Parceiro, Banco e Não
 * identificado (card 3112).
 *
 * Cada pessoa vira um chip com o nome e, embaixo, o e-mail. Quem foi convidado e **não entrou**
 * aparece apagado, com "não entrou": a lista de convidados sozinha não diz quem estava na sala.
 */
@Component({
  selector: 'app-meeting-participants',
  standalone: true,
  templateUrl: './meeting-participants.component.html',
  styleUrl: './meeting-participants.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingParticipantsComponent {
  readonly participants = input<MeetingParticipantDto[] | null | undefined>([]);

  protected readonly grupos = computed(() => agruparParticipantes(this.participants()));
  protected readonly nome = nomeDoParticipante;

  /** A organização do participante, quando o backend resolveu uma — ajuda a ler o chip. */
  protected organizacao(p: MeetingParticipantDto): string | null {
    return p.companyName || p.partnerName || p.financialInstitutionName || null;
  }
}
